export default __webpack_public_path__ + "static/media/callIconHC.21bde150.svg";